// extracted by mini-css-extract-plugin
module.exports = {"mainLight":"Main_mainLight__2w9MQ","mainDark":"Main_mainDark__3bTe2","tools":"Main_tools__UHdhC","main":"Main_main__uP8-q"};